import React, { Component } from "react";
import BloodStationStore from "../../stores/BloodStationStore";
import { City } from "../../entities";
import styles from "./searchPanel.module.scss";
import { components } from "react-select";
import { inject, observer } from "mobx-react";
import AsyncSelect from "react-select/async";
import redirectTo from "../../utils/redirectTo";
import ResourseStore from "../../stores/ResourseStore";
import { get_city_label } from "../../utils/misc";
import { OptionModel } from "../bloodStations/models";
import { IOption } from "../bloodStations/interfaces";

@inject("bloodStationsStore")
@inject("citiesStore")
@observer
export default class SearchPanel extends Component {
  state: {
    selectedItem: IOption | null;
    prevSelectedItem: IOption | null;
    options: IOption[];
  };
  props: {
    bloodStationsStore?: BloodStationStore;
    defaultCity?: City | string | null;
    citiesStore?: ResourseStore;
    isMobile?: boolean;
    disabled?: boolean;
    filters?: {
      blood_group?: boolean;
      without_registration?: boolean;
      with_typing?: boolean;
      for_moscow?: boolean;
    };
    focused?: boolean;
    changedText?: boolean;
  };
  SearchStyle = {
    control: (styles, state) => ({
      ...styles,
      border: "1px solid #E5E9EE",
      cursor: "text",
      borderRadius: state.menuIsOpen ? "8px 8px 0 0" : "8px",
      boxShadow: state.menuIsOpen
        ? "0px 10px 20px 0px rgba(49,8,8,0.1)"
        : "none",
      borderColor: "transparent",
      backgroundColor: "transparent",
      "&:hover": {
        borderColor: "1px solid #37333F",
        boxShadow: "0px 10px 20px 0px rgba(49,8,8,0.1)",
      },
      zIndex: 1,
      maxHeight: "50px",
    }),
    valueContainer: (styles) => ({
      ...styles,
      padding: "13px",
    }),
    input: (styles) => ({
      ...styles,
      border: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    placeholder: (styles) => ({
      ...styles,
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "14px",
      lineHeight: "17px",
      letterSpacing: "-0.01em",
      color: "#C1C4CA",
      padding: "12px 12px 12px 3px",
      marginLeft: "0",
    }),
    menu: (styles) => {
      return {
        ...styles,
        zIndex: 3,
        marginTop: 0,
        borderRadius: "0 0 8px 8px",
        boxShadow: "0px 10px 20px 0px rgba(49,8,8,0.1)",
      };
    },
    menuList: (styles) => ({
      ...styles,
      paddingTop: "8px",
      paddingBottom: "12px",
    }),
    groupHeading: (styles) => {
      return {
        ...styles,
        color: "#C1C4CA",
        fontSize: "16px",
        fontWeight: "normal",
        lineHeight: "19px",
      };
    },
    option: (styles, state) => {
      let bacColor = "transparent";
      if (state.isFocused) bacColor = "#F6F7F8";
      if (state.isSelected) bacColor = "#F6F7F8";
      return {
        ...styles,
        backgroundColor: bacColor,
        "&:active": { backgroundColor: "#F73E3E" },
      };
    },
  };

  SearchStyleMobile = {
    ...this.SearchStyle,
    control: (styles) => ({
      ...styles,
      border: 0,
      cursor: "text",
      borderRadius: 0,
      boxShadow: 0,
      borderBottom: "1px solid rgba(43, 46, 74, 0.08)",
      borderColor: "transparent",
      backgroundColor: "transparent",
      "&:hover": {
        borderColor: "1px solid #37333F",
        boxShadow: "0px 10px 20px 0px rgba(49,8,8,0.1)",
      },
      zIndex: 1,
    }),
    valueContainer: (styles) => ({
      ...styles,
      padding: "12px 12px 24px",
    }),
    indicatorContainer: () => ({
      display: "none",
    }),
    dropdownIndicator: () => ({
      display: "none",
    }),
    input: (styles) => ({
      ...styles,
      fontSize: "18px",
    }),
    option: (styles, state) => {
      let bacColor = "transparent";
      if (state.isFocused) bacColor = "#F6F7F8";
      if (state.isSelected) bacColor = "#F6F7F8";
      return {
        ...styles,
        backgroundColor: bacColor,
        "&:active": { backgroundColor: "#F6F7F8" },
      };
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedItem: null,
      prevSelectedItem: null,
      options: null,
    };
  }

  getCityOptions() {
    return this.props.citiesStore
      .load(25, 1, this.props.filters)
      .then((r) => {
        const opt = r.records.map((item) => {
          return new OptionModel({
            ...item.data,
            type: "city",
            address: get_city_label(item.data),
          });
        });
        this.setState({
          options: [{ label: "Города", options: opt }],
        });
      })
      .catch(() => {});
  }

  updateOptions(value: string) {
    return this.props.bloodStationsStore
      .getDataForSearch(value, this.props.filters)
      .then((r) => {
        const bss = r.blood_stations?.map((bs) => {
          return new OptionModel(bs);
        });
        const cities = r.cities?.map((city) => {
          return new OptionModel(city);
        });
        this.setState({
          options: [
            { label: "Города", options: cities },
            { label: "Центры крови", options: bss },
          ],
        });
        return [
          { label: "Города", options: cities },
          { label: "Центры крови", options: bss },
        ];
      })
      .catch(() => {
        return this.getCityOptions();
      });
  }

  componentDidMount() {
    if (this.props.defaultCity) {
      const defSelected = {
        label: this.props.defaultCity?.title,
        value: this.props.defaultCity?.id,
      };
      this.setState({
        selectedItem: defSelected,
        prevSelectedItem: defSelected,
      });
      this.updateOptions(this.props.defaultCity?.title);
    } else {
      this.getCityOptions();
    }
  }

  selectItem = (event) => {
    if (event.slug) {
      redirectTo(`/bloodstations/${event.slug}/`);
    }

    if (event.value && event.type === "blood_station") {
      // redirectTo(`/bloodstations/${event.value}/`)
      if (typeof window !== "undefined") {
        window.location.pathname = `/bloodstations/${event.value}/`;
      }
    }

    const value = {
      label: event.defaultLabel,
      value: event.value,
    };
    this.setState({
      prevSelectedItem: this.state.selectedItem,
      selectedItem: value,
    });
  };

  changeInput = (event) => {
    if (!event) {
      return this.getCityOptions();
    }
  };

  onMenuOpen = () => {
    this.setState({
      selectedItem: null,
    });
  };

  promiseOptions = (value) => {
    return this.updateOptions(value);
  };

  render() {
    const { selectedItem, options } = this.state;
    const { disabled } = this.props;
    const noOptMessage = (
      <span className={styles.SearchPanel_NotFounded}>
        Если не нашли свой город в списке,
        <br />
        но точно знаете,
        <br />
        что в нём есть центр крови,
        <br />
        напишите нам на <br />
        <a href="mailto:support@donorsearch.org">support@donorsearch.org</a>
      </span>
    );
    return (
      <AsyncSelect
        className={styles.SearchPanel}
        placeholder={"Город или центр крови"}
        options={options}
        styles={this.props.isMobile ? this.SearchStyleMobile : this.SearchStyle}
        value={this.props.focused ? null : selectedItem}
        hideSelectedOptions={true}
        menuIsOpen={this.props.isMobile}
        isDisabled={disabled}
        onChange={this.selectItem}
        autoFocus={this.props.focused}
        onInputChange={this.changeInput}
        noOptionsMessage={
          options ? () => noOptMessage : () => <span>Поиск...</span>
        }
        components={{ ValueContainer }}
        onMenuOpen={this.onMenuOpen}
        isSearchable={true}
        defaultOptions={options}
        loadOptions={this.promiseOptions}
        loadingMessage={() => "Поиск..."}
        maxMenuHeight={this.props.isMobile ? "calc(100vh - 149px)" : 450}
      />
    );
  }
}

const ValueContainer = ({ children, ...props }) => {
  return (
    components.ValueContainer && (
      <components.ValueContainer {...props}>
        <div style={{ display: "flex", width: "100%" }}>
          {!!children && (
            <img
              style={{ marginRight: "12px" }}
              src="/static/images/icons/BSSearch.svg"
              alt=""
            />
          )}
          <div style={{ position: "relative", width: "100%" }}>{children}</div>
        </div>
      </components.ValueContainer>
    )
  );
};
